import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { customToast } from "src/utils/toast";
import Client from "src/types/models/Client";
import { getClient as _get } from "src/network/client";
import { CompanyUsageConstraints } from "src/types";

interface State {
  client?: Client;
}

const getInitialState = (): State => ({
  client: undefined
});

// ACTIONS

// This action will fetch the client data
export const getClient = createAsyncThunk("client/get", async () => {
  try {
    return await _get();
  } catch (e: any) {
    customToast({ message: "Authentication error: " + (e?.message || "Unknown") });
    return undefined;
  }
});

export const setClient = createAsyncThunk("client/set", async (data: Client) => {
  return data;
});

// This action will help update client company constraints
export const setUsageConstraints = createAsyncThunk(
  "client/setUsageConstraints",
  async (data: CompanyUsageConstraints) => {
    return data;
  }
);

const authSlice = createSlice({
  name: "auth",
  initialState: getInitialState(),
  reducers: {},
  extraReducers: (bl) => {
    bl.addCase(getClient.fulfilled, (state, action) => {
      state.client = action.payload;
    });
    bl.addCase(setClient.fulfilled, (state, action) => {
      state.client = action.payload;
    });
    bl.addCase(setUsageConstraints.fulfilled, (state, action) => {
      if (!state.client) return;
      state.client.Company.UsageConstraints = action.payload;
      state.client = { ...state.client };
    });
  }
});

export default authSlice.reducer;
